import React, { useState, useEffect } from "react";
import _ from "lodash";
import api from "../../utils/api";

import { Loader } from "../../atoms";
import { InputText, InputCheckboxRadio, SingleCheckbox } from "../../forms";

import {
  _getBaseUrl,
  _getCSRFTokenValue,
  _getTranslation,
} from "../../utils/helper";

const RequestKeyITAS = (props) => {
  const [values, setValues] = useState({
    name_of_organization: "",
    email_address: "",
    address: "",
    website: "",
    mandate: "",
    contact_details: "",
    envisaged_tools_purpose: "",
    my_organization_is_non_for_profit: "",
    i_have_read_and_accept_terms_and_conditions: false,
    i_agree_not_to_share_this_application_with_other_organizations: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [response, setResponse] = useState(null);

  const handleSubmission = async () => {
    setIsLoading(true);
    setErrors({});
    setResponse(null);

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/form/requestitastool/submit", values, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsLoading(false);
        setResponse(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.data?.errors) {
          setErrors(err.data.errors);
        } else {
          setErrors({
            general_error: ["Something went wrong, please try again."],
          });
        }
      });
  };

  return (
    <React.Fragment>
      {response?.message && _.isString(response.message) ? (
        <p className="font-bold">{response.message}</p>
      ) : (
        <React.Fragment>
          <InputText
            label="Name of organization*"
            value={values.name_of_organization}
            onChange={(e) => {
              setValues({ ...values, name_of_organization: e.target.value });
            }}
            error={_.get(errors, "name_of_organization[0]")}
            twoColumnLayout
          />
          <InputText
            label="Email address*"
            type="email"
            value={values.email_address}
            onChange={(e) => {
              setValues({ ...values, email_address: e.target.value });
            }}
            error={_.get(errors, "email_address[0]")}
            twoColumnLayout
          />
          <InputText
            label="Address*"
            value={values.address}
            onChange={(e) => {
              setValues({ ...values, address: e.target.value });
            }}
            error={_.get(errors, "address[0]")}
            twoColumnLayout
          />
          <InputText
            label="Website"
            value={values.website}
            onChange={(e) => {
              setValues({ ...values, website: e.target.value });
            }}
            error={_.get(errors, "website[0]")}
            twoColumnLayout
          />
          <InputText
            label="Mandate*"
            value={values.mandate}
            onChange={(e) => {
              setValues({ ...values, mandate: e.target.value });
            }}
            error={_.get(errors, "mandate[0]")}
            twoColumnLayout
          />
          <InputText
            label="Contact details*"
            type="textarea"
            value={values.contact_details}
            onChange={(e) => {
              setValues({ ...values, contact_details: e.target.value });
            }}
            error={_.get(errors, "contact_details[0]")}
            twoColumnLayout
          />
          <InputText
            label="Envisaged tool's purpose*"
            type="textarea"
            value={values.envisaged_tools_purpose}
            onChange={(e) => {
              setValues({ ...values, envisaged_tools_purpose: e.target.value });
            }}
            error={_.get(errors, "envisaged_tools_purpose[0]")}
            twoColumnLayout
          />
          <p className="text-mobileS md:text-desktopS mt-8">
            Read these{" "}
            <a href={props?.data?.terms || "#"} target="_blank">
              terms and conditions
            </a>{" "}
            before ticking relevant boxes below:
          </p>
          <InputCheckboxRadio
            type="radio"
            label="My organization is non-for-profit"
            name="my_organization_is_non_for_profit"
            options={[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ]}
            value={values.my_organization_is_non_for_profit}
            onChange={(value) => {
              setValues({
                ...values,
                my_organization_is_non_for_profit: value,
              });
            }}
            error={_.get(errors, "my_organization_is_non_for_profit[0]")}
            twoColumnLayout
            listClass="inline-flex gap-y-4 gap-x-8 mt-2"
          />
          <SingleCheckbox
            label="I have read and accept terms and conditions"
            value={values.i_have_read_and_accept_terms_and_conditions}
            onChange={(value) => {
              setValues({
                ...values,
                i_have_read_and_accept_terms_and_conditions: value,
              });
            }}
            error={_.get(
              errors,
              "i_have_read_and_accept_terms_and_conditions[0]"
            )}
          />
          <SingleCheckbox
            label="I agree not to share this application with other organizations"
            value={
              values.i_agree_not_to_share_this_application_with_other_organizations
            }
            onChange={(value) => {
              setValues({
                ...values,
                i_agree_not_to_share_this_application_with_other_organizations:
                  value,
              });
            }}
            error={_.get(
              errors,
              "i_agree_not_to_share_this_application_with_other_organizations[0]"
            )}
          />

          {_.get(errors, "general_error[0]") && (
            <div className="text-red-500 font-bold mt-8">
              {_.get(errors, "general_error[0]")}
            </div>
          )}

          <div className="flex items-center gap-x-4 mt-8">
            <button
              className="btn btn-s--pill"
              onClick={() => handleSubmission()}
            >
              Submit
            </button>
            {isLoading && <Loader />}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default RequestKeyITAS;
